import React, { useCallback, useEffect } from 'react';
import { ChangedOptionInfo, EventInfo } from 'devextreme/events';
import { SortType } from '@/Components/DataTable/types';

export function useOnOptionChanged<TData>(
  onRowsExpand: () => void,
  onPageIndexChange?: (pageIndex: number, pageSize: number) => void,
  onPageSizeChange?: (pageIndex: number, pageSize: number) => void,
  onSearchItem?: (value: string) => void,
  onColumnSort?: (column: keyof TData, sortType?: SortType) => void,
) {
  const pagingRef = React.useRef<{
    pageIndex?: number;
    pageSize?: number;
  }>({});

  useEffect(() => {
    pagingRef.current = {};
  }, []);

  return useCallback((e: ChangedOptionInfo & EventInfo<any>) => {
    if (e.fullName.startsWith('columns[')) {
      const match = e.fullName.match(/columns\[(\d+)]\.sortOrder/);

      if (match) {
        const columnIndex = parseInt(match[1], 10);
        const columnName = e.component.option(`columns[${columnIndex}].dataField`);

        onColumnSort?.(columnName, e.value);
      }
    }

    if (e.fullName === 'paging.pageIndex') {
      onRowsExpand();

      const pageIndex = e.value;

      if (pagingRef.current.pageIndex == undefined) {
        pagingRef.current.pageIndex = pageIndex;
      } else {
        const pageSize = e.component.option('paging.pageSize');
        onPageIndexChange?.(pageIndex, pageSize);
      }
    }

    if (e.fullName === 'paging.pageSize') {
      onRowsExpand();

      const pageSize = e.value;

      if (pagingRef.current.pageSize == undefined) {
        pagingRef.current.pageSize = pageSize;
      } else {
        onPageSizeChange?.(0, pageSize);
        e.component.option('paging.pageIndex', 0);
      }
    }

    if (e.fullName == 'searchPanel.text') {
      onSearchItem?.(e.value);
    }
  }, []);
}
